import React, { useEffect, useRef, useState } from 'react'
import Error_false from '../../../error/error-false'
import Resizer from 'react-image-file-resizer'
import ModalCropper from '../employee-info/modal-cropper'
import { Button, Image } from 'react-bootstrap'
import { useDropzone } from 'react-dropzone'
import {
  createFilesImagesAPI,
  getFilesImagesAPI,
  updateFilesImagesAPI
} from '../../../../services/files'
import ModalCustom from '../../../modal-custom'
import SwalCustom from '../../../../alert/swal-custom'
import imgUser from '../../../../images/user.png'
import Swal from 'sweetalert2'

function AddImgType({ imgtype, org_code }) {
  const [image, setImage] = useState({})
  const [imagePreview, setImagePreview] = useState(null)
  const [isSave, setIsSave] = useState(false)
  const [loading, setLoading] = useState(false)
  const { getRootProps, getInputProps } = useDropzone({
    maxFiles: 1,
    maxSize: 20000000,
    accept: {
      'image/png': ['.png', '.jpg', '.jpeg']
    },
    onDrop: (acceptedFiles) => {
      acceptedFiles.forEach(async (file) => {
        let reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          handleShow()
          setImage({
            type: file.type,
            name: file.name,
            data: reader.result
          })
        }
      })
    },
    onDropRejected: () => {
      Swal.fire({
        icon: 'error',
        title: 'You can only upload 1 file & maximum size of 8 MB.',
        showConfirmButton: false,
        timer: 3000
      })
    }
  })
  useEffect(() => {
    setImagePreview(imgtype.url ?? null)
  }, [imgtype])

  const resizeFile = (file, type) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        imgtype.width,
        imgtype.height,
        type,
        100,
        0,
        (uri) => {
          resolve(uri)
        },
        'base64'
      )
    })

  const [show, setShow] = useState(false)

  const handleClose = () => {
    setShow(false)
  }
  const handleShow = () => setShow(true)
  const cropperRef = useRef()

  const onSaveCrop = async () => {
    await setIsSave(true)
    const cropper = cropperRef.current?.cropper
    setImagePreview(cropper.getCroppedCanvas().toDataURL())
    const file = await fnImgCrop(cropper.getCroppedCanvas().toDataURL())
    imagePreview ? updateFilesImages(file) : createFilesImages(file)
  }

  const createFilesImages = async (file) => {
    var c_formData = new FormData()
    c_formData.append('file', file)
    c_formData.append('orgId', org_code.orgId)
    c_formData.append('code', org_code.code)
    c_formData.append('typeId', imgtype.id)
    const result = await createFilesImagesAPI(c_formData)
    if (!result) return
    if (result.status) {
      SwalCustom({
        icon: 'success',
        title: 'Success!',
        text: 'The Image has been successfully saved into the system.',
        showConfirmButton: false,
        timer: 1500
      }).then(() => {
        setImage({})
      })
    } else {
      Error_false(result)
    }
    setIsSave(false)
    setShow(false)
  }

  const updateFilesImages = async (file) => {
    var c_formData = new FormData()
    c_formData.append('file', file)

    const param = {
      orgId: org_code.orgId,
      code: org_code.code,
      typeId: imgtype.id
    }
    const result = await updateFilesImagesAPI(param, c_formData)
    if (!result) return
    if (result.status) {
      SwalCustom({
        title: 'Success!',
        text: 'The Image has been successfully saved into the system.',
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        setImage({})
      })
    } else {
      Error_false(result)
    }
    setIsSave(false)
    setShow(false)
  }

  const fnImgCrop = async (croppedImage) => {
    let blob = await fetch(croppedImage).then((r) => r.blob())

    blob.lastModifiedDate = await new Date()
    blob.name = image.name

    const myFile = await new File([blob], image.name, {
      type: image.type
    })

    const imageResize = await resizeFile(myFile, image.type)
    let reblob = await fetch(imageResize).then((r) => r.blob())

    reblob.lastModifiedDate = await new Date()
    reblob.name = image.name

    const reFile = await new File([reblob], image.name, {
      type: image.type
    })

    if (croppedImage != null) {
      return reFile
    } else {
      return {}
    }
  }

  const getImageURL = async () => {
    setLoading(true)
    const body = {
      orgId: org_code.orgId,
      code: org_code.code,
      typeId: imgtype.id
    }
    const result = await getFilesImagesAPI(body)
    setLoading(false)
    if (!result) return
    if (result.status) {
      handleDownload(result.result[0].url)
    }
  }

  const [showDownload, setShowDownload] = useState(false)
  const handleCloseDownload = () => {
    setShowDownload(false)
  }
  async function handleDownload(url) {
    fetch(url)
      .then((res) => res.blob())
      .then((file) => {
        let tempUrl = URL.createObjectURL(file)
        const aTag = document.createElement('a')
        aTag.href = tempUrl
        aTag.download = imgtype.name + '.jpg'

        aTag.click()

        URL.revokeObjectURL(tempUrl)
        aTag.remove()
        setLoading(false)
      })
      .catch(() => {
        SwalCustom({
          title: 'Error!',
          text: 'Failed to download file'
        })
        setLoading(false)
      })
  }

  return (
    <>
      <div
        style={{
          borderRadius: '15px',
          width: '160px',
          backgroundColor: '#EFEFEF',
          aspectRatio: 1 / 1,
          flexGrow: 1
        }}
      >
        <div
          className="d-flex justify-content-center align-items-center"
          style={{
            margin: '1rem',
            borderRadius: '15px',
            backgroundColor: '#fff',
            border: imagePreview ? '0' : '1.5px dashed  #878787',
            // aspectRatio: imgtype.x / imgtype.y,
            aspectRatio: 1,
            flexGrow: 1
          }}
        >
          {imagePreview ? (
            <div
              className="text-center "
              onClick={() => {
                setShowDownload(true)
              }}
            >
              <div className="position-relative box-profile">
                <Image
                  src={imagePreview}
                  className=" img-profile"
                  fluid
                  style={{ maxHeight: 198 }}
                  onError={(event) => {
                    event.target.src = imgUser
                    event.onerror = null
                  }}
                />

                <div
                  className="position-absolute  d-grid align-content-center img-profile-text"
                  style={{
                    top: '50%',
                    left: '50%',
                    backgroundColor: '#0006',
                    height: '100%',
                    width: '100%',
                    transform: 'translate(-50%, -50%)'
                  }}
                >
                  <span className="text-white font-small-2">
                    {imgtype.name}
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center">
              {imgtype.icon}
              {/* <p className="mb-0 font-small-2 fw-light mt-3"  style={{ fontSize: '12px' }}>{imgtype.name}</p> */}
              <p
                className="mb-0 fw-light text-muted mt-4"
                style={{ fontSize: '9px' }}
              >
                Files Supported .JPG, .PNG
              </p>
            </div>
          )}
        </div>
        <div
          style={{
            margin: '1rem'
          }}
        >
          <div
            {...getRootProps({
              className: 'dropzone-img z-index-1 mt-2'
            })}
          >
            <input
              {...getInputProps({
                className: 'form-control z-index-1',
                style: {
                  border: '0px',
                  clip: 'rect(0px, 0px, 0px, 0px)',
                  clipPath: 'inset(50%)',
                  height: 1,
                  margin: '0px -1px -1px 0px',
                  overflow: 'hidden',
                  padding: 0,
                  // position: 'absolute',
                  width: 1,
                  whiteSpace: 'nowrap'
                }
              })}
            />

            {imagePreview ? (
              <>
                <Button
                  size="sm"
                  variant="primary-drak"
                  className="w-100 rounded-3 border"
                  style={{ backgroundColor: '#1A2B45' }}
                >
                  Edit
                </Button>
              </>
            ) : (
              <>
                <Button size="sm" className="w-100 rounded-3 border">
                  Upload
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
      {show && (
        <ModalCropper
          isSave={isSave}
          setIsSave={setIsSave}
          imgtype={imgtype}
          show={show}
          handleClose={handleClose}
          image={image?.data}
          cropperRef={cropperRef}
          onSaveCrop={onSaveCrop}
        />
      )}

      {showDownload && (
        <ModalCustom
          width={350}
          open={showDownload}
          onCancel={handleCloseDownload}
        >
          <div className="text-center ">
            <Image src={imagePreview} className="rounded-4 img-profile" fluid />
          </div>

          <div className="text-center mt-4">
            <Button variant="outline-secondary" onClick={getImageURL}>
              {loading ? 'Downloading...' : 'Download'}
            </Button>
          </div>
        </ModalCustom>
      )}
    </>
  )
}

export default AddImgType
